import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { StudentComment } from './student-comment.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class StudentCommentService  extends AbstractEntityService {

    protected resourceUrl = 'api/student-comments';
    private resourceSearchUrl = 'api/_search/student-comments';
    protected resourceCountUrl = 'api/_search/count/student-comments';

    constructor(protected http: HttpClient) { super(http); }

    create(StudentComment: StudentComment): Observable<StudentComment> {
        let copy: StudentComment = Object.assign({}, StudentComment);
        return this.http.post<StudentComment>(this.resourceUrl, copy).map((res: StudentComment) => {
            return res;
        });
    }

    update(StudentComment: StudentComment): Observable<StudentComment> {
        let copy: StudentComment = Object.assign({}, StudentComment);
        return this.http.put<StudentComment>(this.resourceUrl, copy).map((res: StudentComment) => {
            return res;
        });
    }

    find(id: number): Observable<StudentComment> {
        return this.http.get<StudentComment>(`${this.resourceUrl}/${id}`).map((res: StudentComment) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<StudentComment[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<StudentComment[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<StudentComment[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<StudentComment[]>>(this.resourceSearchUrl, options)
            ;
    }

    public getHealthCommentClass(): string {
        // return 'fa fa-medkit';
        return 'badge-danger';
    }

    public getFinantialCommentClass(): string {
        return 'fa fa-money';
    }

    public getInstructionCommentClass(): string {
        return 'fa fa-eye';
    }

    public getStudentCommentBadgeStyle(studenCommentType: String): String {
        switch (studenCommentType) {
            case 'HEALTH':
                return 'badge-danger';
            case 'FINANTIAL':
                return 'badge-success';
            case 'INSTRUCTION':
                return 'badge-warning';
            default:
                return 'badge-info';
        }
    }

    public getStudentCommentStatusBadgeStyle(studenCommentStatus: String): String {
        switch (studenCommentStatus) {
            case 'OPEN':
                return 'badge-danger';
            case 'DISMISSED':
                return 'badge-success';
            default:
                return 'badge-info';
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment.service.ts